import { IIconProps } from '../../interfaces/IconProps.interface'

export const IconCalendar = ({ color = 'white', className }: IIconProps) => {
  return (
    <svg
      className={`w-full ${className}`}
      fill='none'
      viewBox='0 0 16 16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14 6.66658H2M10.6667 1.33325V3.99992M5.33333 1.33325V3.99992M7 9.33325L8 8.66658V11.9999M7.16667 11.9999H8.83333M5.2 14.6666H10.8C11.9201 14.6666 12.4801 14.6666 12.908 14.4486C13.2843 14.2569 13.5903 13.9509 13.782 13.5746C14 13.1467 14 12.5867 14 11.4666V5.86659C14 4.74648 14 4.18643 13.782 3.75861C13.5903 3.38228 13.2843 3.07632 12.908 2.88457C12.4801 2.66659 11.9201 2.66659 10.8 2.66659H5.2C4.07989 2.66659 3.51984 2.66659 3.09202 2.88457C2.71569 3.07632 2.40973 3.38228 2.21799 3.75861C2 4.18643 2 4.74648 2 5.86659V11.4666C2 12.5867 2 13.1467 2.21799 13.5746C2.40973 13.9509 2.71569 14.2569 3.09202 14.4486C3.51984 14.6666 4.07989 14.6666 5.2 14.6666Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
